module.exports = __webpack_public_path__ + "static/media/linkedin.f3734a1b.svg";